import request from './../request.js'

// 列表渲染以及查询​/dev-api​/iot​/device​/operation​/list
export function operationList(query){
    return request({
      url: '/iot/device/operation/list.do?',
      method: 'get',
      params: query
    })
  }

/** 任务数据异步导出，查询条件与列表一致（gyAgentId、imei、startTime、endTime） */
export function exportOperationExcelSync(query) {
  return request({
    url: '/iot/device/operation/exportExcelSync.do?',
    method: 'get',
    params: query
  })
}